module.exports = __webpack_public_path__ + "img/11_78.54f423bc.png";